/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext } from 'react';
import { Button, Icon, Link, Spinner, VStack } from '@chakra-ui/react';
import EventsContext from 'contexts/EventsContext';
import {
  fancyBearsContract,
  honeyJarsContract,
  honeyVestingContract,
} from 'config';
import HoneyReleasedEventTimelineItem from 'components/HoneyReleasedEventTimelineItem';
import useTranslate from 'hooks/useTranslate';
import { FaExternalLinkAlt } from 'react-icons/fa';
import ScrollableArea from 'components/ScrollableArea';
import EmptyState from 'components/EmptyState';
import TokenTransferEventTimelineItem from 'components/TokenTransferEventTimelineItem';

const EventsTimeline = () => {
  const translate = useTranslate();
  const { events } = useContext(EventsContext);

  return events ? (
    <>
      {events.length === 0 ? (
        <EmptyState mt="8" mb="4" opacity="0.8" />
      ) : (
        <ScrollableArea maxH="320px" overflowY="auto">
          <VStack spacing="2" w="full" align="stretch">
            {events.map(({ contractAddress, log, block }, i) =>
              contractAddress === fancyBearsContract.address ? (
                <TokenTransferEventTimelineItem
                  type="bear"
                  key={i}
                  log={log}
                  timestamp={block.timestamp}
                />
              ) : contractAddress === honeyJarsContract.address ? (
                <TokenTransferEventTimelineItem
                  type="jar"
                  key={i}
                  log={log}
                  timestamp={block.timestamp}
                />
              ) : log.name === 'HoneyReleasedFromBear' ? (
                <HoneyReleasedEventTimelineItem
                  key={i}
                  type="bear"
                  log={log}
                  timestamp={block.timestamp}
                />
              ) : log.name === 'HoneyReleasedFromJar' ? (
                <HoneyReleasedEventTimelineItem
                  key={i}
                  type="jar"
                  log={log}
                  timestamp={block.timestamp}
                />
              ) : null
            )}
          </VStack>
        </ScrollableArea>
      )}

      <Button
        as={Link}
        isFullWidth
        mt="6"
        href={`https://etherscan.io/address/${honeyVestingContract.address}#events`}
        target="_blank"
        colorScheme="dark"
        rightIcon={<Icon as={FaExternalLinkAlt} />}
      >
        {translate('timline:view')}
      </Button>
    </>
  ) : (
    <Spinner my="6" mx="auto" display="block" />
  );
};

export default EventsTimeline;
